import React, { useState, useEffect } from "react";
import { MdEmail } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { Formik, Field, Form } from "formik";
import InputLogin from "../InputLogin";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Overlay from "../Overlay";
import axios from "../../axios";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import "./locationdropdown.css";
import { loginValidator } from "../../utils/validators";
import Input from "../../components/Input";
import { Checkbox } from "@material-ui/core";
import "./style.scss";
import jobDashLogo from "../../assets/images/jobDashlogo.png";
console.log("welcome")
console.log("object", Cookies.l)
const useStyles = makeStyles((theme) => ({
  formStyle: {
    width: "100%",
    padding: "2rem",
    overflow: "scroll",
  },
  "@media (max-width: 780px)": {
    formStyle: {
      padding: "1.8rem",
    },
  },
  "@media (max-width: 480px)": {
    formStyle: {
      padding: "1.3rem",
    },
  },
}));


const LoginSection = ({ setUsers, userData }) => {
  // console.log("welcome")

  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const accessToken = localStorage.getItem("token") || sessionStorage.getItem("token");
    // console.log("accessToken",accessToken)
    if (accessToken) {
      navigate("/dashboard");
    }
  }, []);




  const [loginValues, setLoginValues] = useState({
    email: "",
    password: "",

  });




  // this is for system id and system name
  const getDeviceId = () => {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem("deviceId", deviceId);
    }
    return deviceId;
  };

  const getDeviceType = () => {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Windows NT")) return "Windows";
    if (userAgent.includes("Mac")) return "MacOS";
    if (userAgent.includes("Linux")) return "Linux";
    if (userAgent.includes("Android")) return "Android";
    if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";

    return "Unknown OS";
  };



  const handleLogin = async (values) => {
    setIsLoading(true);

    const deviceId = getDeviceId();
    const deviceType = getDeviceType();



    const formvalues = {
      email: values.email,
      password: values.password,
      deviceId: String(deviceId),
      deviceType: String(deviceType),
    };
    try {
      const { data } = await axios.post("/login", formvalues);



      localStorage.setItem("email", data?.data?.admin?.email);
      localStorage.setItem("token", data?.data?.accessToken);
      localStorage.setItem("userData", JSON.stringify(data?.data?.admin));


      // sessionStorage.setItem("email", data?.data?.admin?.email);
      // sessionStorage.setItem("token", data?.data?.accessToken);
      // sessionStorage.setItem("userData", JSON.stringify(data?.data?.admin));

      Cookies.remove("showProfileSidebar");
      setUsers(data?.data?.admin);



      if (data?.data?.admin?.userType === "subAdmin") {
        const modulePermissions = data?.data?.admin?.adminpermissions?.modules;

        if (modulePermissions && modulePermissions.length > 0) {
          // Find the first module with at least one permission set to true
          const allowedModule = modulePermissions.find(module =>
            Object.values(module.permissions).some(permission => permission === true)
          );

          if (allowedModule) {
            // Map moduleName to route
            const moduleRoutes = {
              "Dashboard": "dashboard",
              "User Management": "userManagement",
              "Skill Management": "skillsManagement",
              "Blacklist Word Management": "blockManagement",
              "Commission Management": "commissionSettings",
              "Gigs Management": "gigsManagement",
              "Reported Gig Management": "reportedGigManagement",
              "Payment Management": "paymentManagement",
              "CMS Management": "cmsManagement",
              "Notification Management": "notificationManagement",
              "Leader board": "leaderboardManagement",
              "Ticket Management": "ticketManagement",
              "Feedback Management": "feedbackManagement"
            };

            const firstRoute = moduleRoutes[allowedModule.moduleName] || "dashboard";
            navigate(`/${firstRoute}`);
          } else {
            navigate("/dashboard");
          }
        } else {
          navigate("/dashboard");
        }
      } else {
        navigate("/dashboard");
      }
  //   } catch (error) {
  //     console.log("objecterror", error)
  //     if (error.response.status === 422) {
  //       toast.error(`${error.response.data?.errors[0].msg}`, {
  //         position: "top-right",
  //       });
  //     }

  //     else {
  //       toast.error(`${error.response.data?.message}`, {
  //         position: "top-right",
  //       });
  //     }
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

}catch (error) {
  console.log("objecterror", error);

  if (error.response && error.response.data) {
    toast.error(error.response.data.message, {
      position: "top-right",
    });
  }
  //  else {
  //   toast.error("Something went wrong!", {
  //     position: "top-right",
  //   });
  // }
} finally {
  setIsLoading(false);
}
  }




  return (
    <>
      <div>
        <section className="auth">
          <div className="login">
            <div className="login-text-cant">
              <img src={jobDashLogo} style={{ height: "75.78px", width: "97px" }} />
            </div>
            <div className="logincontainer">
              <div className="login-main-cant">
                <div className="loginheading">
                  <h4>Login as Admin</h4>
                </div>
                <div className="form">
                  <Formik
                    enableReinitialize
                    initialValues={loginValues}
                    validate={loginValidator}
                    validateOnChange
                    onSubmit={(values) => handleLogin(values, false)}
                  >
                    {(formikBag) => {
                      const isFormValid = formikBag.values.email && formikBag.values.password;

                      return (
                        <Form className={classes.formStyleOnly}>
                          <div>
                            <label>Email ID</label>
                            <Field name="email">
                              {({ field }) => (
                                <div className="py-2">
                                  <div className="form-controlcont">
                                    <InputLogin
                                      {...field}
                                      type="email"
                                      onChange={(e) => {
                                        formikBag.setFieldValue("email", e.target.value);
                                      }}
                                      className="form-control login-placeholder"
                                      placeholder="Enter Email ID"
                                    />
                                  </div>
                                  <p className="error">
                                    {formikBag.touched.email && formikBag.errors.email
                                      ? formikBag.errors.email
                                      : null}
                                  </p>
                                </div>
                              )}
                            </Field>
                          </div>
                          <div>
                            <label>Password</label>
                            <Field name="password">
                              {({ field }) => (
                                <div className="py-2">
                                  <div className="form-controlcont position-relative justify-content-between">
                                    <Input
                                      {...field}
                                      type="password"
                                      onChange={(e) => {
                                        formikBag.setFieldValue("password", e.target.value);
                                      }}
                                      className="form-control login-placeholder"
                                      placeholder="Enter Password"
                                    />
                                  </div>
                                  <p className="error">
                                    {formikBag.touched.password && formikBag.errors.password
                                      ? formikBag.errors.password
                                      : null}
                                  </p>
                                </div>
                              )}
                            </Field>
                          </div>

                          <button
                            type="submit"
                          >
                            Login
                          </button>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
                <div
                  className="forgotText"

                  onClick={() => {
                    navigate("/eMail");
                  }}
                >
                  Forgot Password?
                </div>
              </div>
            </div>
          </div>
          {isLoading && <Overlay />}
        </section>
      </div>
      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

// No need for withRouter, as useNavigate is used
export default connect(mapStateToProps, mapDispatchToProps)(LoginSection);
